import { Link } from "react-router-dom";
import { ArrowRight, Upload, Layers, Download } from "lucide-react";
import { HeaderNav } from "../components/HeaderNav";
import { BeforeAfter } from "../components/BeforeAfter";
import { useLang } from "../lib/i18n";

const EXAMPLES = [
  { before: "/examples/p1_before.jpg", after: "/examples/p1_bg_prompt.jpg", key: "ex_bg_prompt" },
  { before: "/examples/p1_before.jpg", after: "/examples/p1_lightsaber.jpg", key: "ex_saber" },
  { before: "/examples/p2_before.jpg", after: "/examples/p2_ice.jpg", key: "ex_ice" },
  { before: "/examples/v_before.jpg", after: "/examples/v_bg.jpg", key: "ex_video" },
];

const STEPS = [
  { icon: Upload, t: "how_1", d: "how_1d" },
  { icon: Layers, t: "how_2", d: "how_2d" },
  { icon: Download, t: "how_3", d: "how_3d" },
];

export default function Landing() {
  const { t } = useLang();
  return (
    <div className="frz-page">
      <HeaderNav tall />
      <section className="frz-hero" data-testid="landing-hero"
        style={{ backgroundImage: "linear-gradient(180deg, rgba(7,17,31,0.25) 0%, rgba(7,17,31,0.35) 45%, #07111f 100%), url(/brand/header.jpg)" }}>
        <p className="frz-kicker fade-1">{t("hero_kicker")}</p>
        <h1 className="frz-hero-title fade-2" data-testid="hero-tagline">{t("hero_title")}</h1>
        <p className="frz-hero-sub fade-3">{t("hero_sub")}</p>
        <div className="frz-hero-cta fade-4">
          <Link to="/studio" className="frz-btn frz-btn-primary frz-btn-lg" data-testid="hero-start-button">
            {t("start")} <ArrowRight size={18} />
          </Link>
          <a href="#examples" className="frz-btn frz-btn-ghost frz-btn-lg" data-testid="hero-examples-link">{t("hero_secondary")}</a>
        </div>
      </section>

      <section id="examples" className="frz-section" data-testid="examples-section">
        <div className="frz-section-head">
          <h2 className="frz-h2">{t("examples_title")}</h2>
          <p className="frz-muted">{t("examples_sub")}</p>
        </div>
        <div className="frz-ba-grid">
          {EXAMPLES.map((e, i) => (
            <BeforeAfter key={e.key} before={e.before} after={e.after} label={t(e.key)} testId={`example-${i}`} />
          ))}
        </div>
      </section>

      <section className="frz-section" data-testid="how-section">
        <h2 className="frz-h2">{t("how_title")}</h2>
        <ol className="frz-steps">
          {STEPS.map(({ icon: Icon, t: k, d }, i) => (
            <li key={k} className="frz-step">
              <span className="frz-step-n">0{i + 1}</span>
              <Icon size={22} className="frz-step-icon" />
              <h3>{t(k)}</h3>
              <p className="frz-muted">{t(d)}</p>
            </li>
          ))}
        </ol>
        <Link to="/studio" className="frz-btn frz-btn-primary frz-btn-lg" data-testid="bottom-start-button">
          {t("start")} <ArrowRight size={18} />
        </Link>
      </section>
      <footer className="frz-footer">{t("footer")}</footer>
    </div>
  );
}
